import React, { useEffect, useState } from "react";
import "./Payment.css";
import { Helmet } from "react-helmet";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function Payment() {
  const headers = {
    token: localStorage.getItem("userToken"),
  };
  let[cartdata,setcartdata]=useState([])
  let navigate=useNavigate();
  async function fetchCartData() {
    
  
    try {
      const response = await axios.get("https://vehex-production.up.railway.app/cart/getCartWithTotalPrice", {
        headers,
        
      });
      console.log(response)

      if(response.data.message==="Cart fetched successfully."){
        setcartdata(response.data.cart)

      }

  
    } catch (error) {
      console.error("Error fetching cart data:", error);
      Swal.fire({
        icon: "error",
        text: error.response?.data?.message || "Failed to fetch cart data.",
        confirmButtonText: "OK",
      });
    }
  }
  
useEffect(()=>{
  fetchCartData();
},[])
  


let phoneRegex = /^\+([1-9][0-9]{0,2})([0-9]{9,11})$/;

  async function addPayment() {
    let name = document.getElementById('name').value;
    let mobile = document.getElementById('mobile').value;
    let address = document.getElementById('address').value;
    let paymentmethod = document.getElementById('paymentmethod').value;
    let nameoncard = document.getElementById('nameoncard').value;
    let cardnumber = document.getElementById('cardnumber').value;
    let cvc = document.getElementById('cvc').value;
    let month = document.getElementById('month').value;
    let year = document.getElementById('year').value;
    if (!phoneRegex.test(mobile)) {
      Swal.fire({
        icon: "error",
        text: "Please enter a valid phone number starting with + and country code.",
        confirmButtonText: "OK",
      });
      return;
    }
    if (cardnumber.length < 16) {
      Swal.fire({
        icon: "error",
        text: `Card number must be 16 digits. You entered ${cardnumber.length} digits.`,
        confirmButtonText: "OK",
      });
      return;
    }
    if (!cardnumber.startsWith("4")) {
      Swal.fire({
        icon: "error",
        text: "Card number must start with 4.",
        confirmButtonText: "OK",
      });
      return;
    }

    if (cvc.length < 3) {
      Swal.fire({
        icon: "error",
        text: `CVC must be 3 digits. You entered ${cvc.length} digits.`,
        confirmButtonText: "OK",
      });
      return;
    }
  
    let body = {
      fullname: name,
      phone: mobile,
      shippingAddress: address,
      paymentMethod: paymentmethod,
      cardDetails: {
        name: nameoncard,
        number: cardnumber,
        cvc: cvc,
        month: month,
        year: year,
      },
    };
  
    try {
      let response = await axios.post(
        'https://vehex-production.up.railway.app/order/addOrder',
        body,
        {
          headers,
        }
      );
      if(response.data.message==="Order created. Payment is pending."){
        Swal.fire({
          icon: "success",
          text: "Payment processed successfully!",
          confirmButtonText: "OK",
        });
        // navigate('')
        console.log(response.data.payment)
        window.location.href=response.data.payment.source.transaction_url
      }
      
      console.log('Success:', response.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: error.response?.data?.message || "Something went wrong.",
        confirmButtonText: "OK",
      });
      console.error('Error:', error.response || error.message);
    }
  }
  
  return (
    <>
      <Helmet>
        <title>Payment</title>
      </Helmet>
      <div className="payment">
        <div className="container py-5">
          <h2 className="heading">Online Payment</h2>
          <div className="payment-content d-grid">
            <table className="tablePayment mb-3">
              <thead className=" border-bottom">
                <tr>
                  <th>Product</th>
                  <th>Quantity</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody id="product-list">
                {cartdata?.items?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.productId?.name || item.packageId?.name}</td>
                    <td>{item.quantity}</td>
                    <td>{item.price} SAR</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className=" border-top">
                <tr className="fs-6 fw-500">
                  <td colspan="2">Total:</td>
                  <td id="total">{cartdata?.totalPrice} SAR</td>
                </tr>
              </tfoot>
            </table>

            <form
  onSubmit={(event) => {
    event.preventDefault(); 
  }}
>
  <label htmlFor="name" className="main-color">
    Full Name:
  </label>
  <input
    type="text"
    id="name"
    name="name"
    className="form-control"
  ></input>

  <label htmlFor="mobile" className="main-color">
    Phone:
  </label>
  <input
    type="tel"
    id="mobile"
    name="mobile"
    className="form-control"
  ></input>

  <label htmlFor="address" className="main-color">
    Address:
  </label>
  <input
    type="text"
    id="address"
    name="address"
    className="form-control"
  ></input>

  <label htmlFor="paymentmethod" className="main-color">
    Payment Method:
  </label>
  <input
    type="text"
    id="paymentmethod"
    name="paymentmethod"
    className="form-control"
    value={"creditcard"}
    disabled
  ></input>

  <label htmlFor="nameoncard" className="main-color">
    Name on the card:
  </label>
  <input
    type="text"
    id="nameoncard"
    name="nameoncard"
    className="form-control"
  ></input>

  <div className="d-flex gap-2 justify-content-between">
    <div className="flex-fill">
      <label htmlFor="cardnumber" className="main-color">
        Card number:
      </label>
      <input
        type="tel"
        id="cardnumber"
        name="cardnumber"
        className="form-control"
        maxLength={16}   
      ></input>
    </div>

    <div className="w-25">
      <label htmlFor="cvc" className="main-color">
        CVC:
      </label>
      <input
        type="tel"
        id="cvc"
        name="cvc"
        className="form-control"
        maxLength={3} 
      ></input>
    </div>
  </div>

  <div className="d-flex justify-content-between gap-2">
    <div className="flex-fill">
      <label htmlFor="month" className="main-color">
        Month:
      </label>
      <select id="month" name="month" className="form-control">
        {[...Array(12)].map((_, index) => (
          <option key={index + 1} value={index + 1}>
            {index + 1}
          </option>
        ))}
      </select>
    </div>

    <div>
      <label htmlFor="year" className="main-color">
        Year:
      </label>
      <select id="year" name="year" className="form-control">
        {[...Array(5)].map((_, index) => {
          const year = new Date().getFullYear() + index;
          return (
            <option key={year} value={year}>
              {year}
            </option>
          );
        })}
      </select>
    </div>
  </div>

  <button  className="btn btn-success w-100" onClick={()=>addPayment()} type="submit">
    Payment Now
  </button>
</form>

          </div>
        </div>
      </div>
    </>
  );
}
